import { IconButton, IconButtonProps, Tooltip } from '@wix/design-system';
import React, { FC } from 'react';

type HeaderIconProps = IconButtonProps & {
  children: React.ReactNode;
  tooltipContent?: string;
};

export const HeaderActionsIcon: FC<HeaderIconProps> = ({ children, tooltipContent, ...iconButtonProps }) => {
  const iconButton = (
    <IconButton size="medium" skin="transparent" {...iconButtonProps}>
      {children}
    </IconButton>
  );
  return (
    <>
      {tooltipContent ? (
        <Tooltip content={tooltipContent} size="small">
          {iconButton}
        </Tooltip>
      ) : (
        iconButton
      )}
    </>
  );
};
